/* eslint-disable prefer-template */
import { HubConnectionBuilder } from '@microsoft/signalr';

const { abp } = window;
const InformationSignalrService = {
  init() {
    abp.signalr.hubs = abp.signalr.hubs || {};

    function configureConnection(connection) {
      // Set the common hub
      abp.signalr.hubs.information = connection;
      let reconnectTime = 5000;
      let tries = 1;
      const maxTries = 8;

      function tryReconnect() {
        if (tries > maxTries) {
          // return;
        } else {
          connection
            .start()
            .then(function () {
              reconnectTime = 5000;
              tries = 1;
              console.log('Reconnected to SignalR Information server!');
            })
            .catch(function () {
              tries += 1;
              reconnectTime *= 2;
              setTimeout(function () {
                tryReconnect();
              }, reconnectTime);
            });
        }
      }

      // Reconnect if hub disconnects
      connection.onclose(function (e) {
        if (e) {
          abp.log.debug('Information hub connection closed with error: ', e);
        } else {
          abp.log.debug('Information hub disconnected');
        }

        if (!abp.signalr.autoConnect) {
          return;
        }
        tryReconnect();
      });
    }

    let url = '';
    if (abp.signalr.remoteServiceBaseUrl) {
      url = abp.signalr.remoteServiceBaseUrl + 'signalr-information';
    }
    if (abp.signalr.qs) {
      url += '?' + abp.signalr.qs;
    }

    const connection = new HubConnectionBuilder()
      .withUrl(url)
      .withAutomaticReconnect()
      .build();

    configureConnection(connection);

    connection
      .start()
      .then(() => {
        abp.log.debug('Information hub Connected!');
      })
      .catch((e) => console.log('Information Hub Connection failed: ', e));

    return connection;
  },
};

export default InformationSignalrService;

// function registerSignalRInformationEvents(connection) {
//   connection.on(signalREventNames.WorkPeriodUpdated, function (message) {
//     abp.event.trigger(signalREventNames.WorkPeriodUpdated, message);
//   });

//   connection.on(signalREventNames.InvoiceUpdated, function (input) {
//     abp.event.trigger(signalREventNames.InvoiceUpdated, input);
//   });
// }
//   abp.event.on('app.chat.connected', function () {
//     $('#chat_is_connecting_icon').addClass('d-none');
//     $('#kt_drawer_chat_toggle').removeClass('d-none');
//     chat.getFriendsAndSettings(function () {
//         chat.bindUiEvents();
//         chat.loadLastState();
//     });
// });
